import { createStyles } from '@lsy-netline-ui/netline-ui';

export default ({ spacing }: Theme) => createStyles({
  root: {
    paddingTop: spacing(1),
  },
});
